module.exports = __webpack_public_path__ + "img/DimensionAI.f50bb8bd.jpg";